<div class="qa-dashboard-wrapper">
  <!-- Quality Metrics Overview -->
  <div class="quality-metrics-overview">
    <div class="quality-metric-tile tile-primary">
      <div class="metric-icon">📊</div>
      <div class="metric-content">
        <div class="metric-number">{{ overallQualityScore }}%</div>
        <div class="metric-text">Quality Score</div>
      </div>
    </div>
    
    <div class="quality-metric-tile tile-success">
      <div class="metric-icon">✓</div>
      <div class="metric-content">
        <div class="metric-number">{{ totalEvaluations }}</div>
        <div class="metric-text">Total Evaluations</div>
      </div>
    </div>
    
    <div class="quality-metric-tile tile-warning">
      <div class="metric-icon">⏳</div>
      <div class="metric-content">
        <div class="metric-number">{{ pendingReviews }}</div>
        <div class="metric-text">Pending Reviews</div>
      </div>
    </div>
    
    <div class="quality-metric-tile tile-info">
      <div class="metric-icon">🎯</div>
      <div class="metric-content">
        <div class="metric-number">{{ complianceRate }}%</div>
        <div class="metric-text">Compliance Rate</div>
      </div>
    </div>
  </div>

  <!-- Quality Metrics by Category -->
  <div class="qa-panel">
    <div class="qa-panel-header">
      <h2 class="qa-panel-title">Quality Metrics by Category</h2>
    </div>
    <div class="qa-panel-body">
      <div class="quality-metrics-grid">
        <div class="quality-metric-item" *ngFor="let metric of qualityMetrics">
          <div class="metric-header-row">
            <div class="metric-title-section">
              <h3 class="metric-item-title">{{ metric.title }}</h3>
              <span class="metric-department">{{ metric.department }}</span>
            </div>
            <div class="metric-trend-indicator" [class.trend-up]="metric.trend === 'up'"
                 [class.trend-down]="metric.trend === 'down'"
                 [class.trend-stable]="metric.trend === 'stable'">
              {{ getTrendIcon(metric.trend) }}
            </div>
          </div>
          
          <div class="metric-score-section">
            <div class="score-display">
              <span class="score-value">{{ metric.score }}</span>
              <span class="score-max">/{{ metric.maxScore }}</span>
            </div>
            <div class="progress-bar-wrapper">
              <div class="progress-bar-track">
                <div class="progress-bar-fill" [style.width.%]="getScorePercentage(metric.score, metric.maxScore)"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Recent Course Evaluations -->
  <div class="qa-panel">
    <div class="qa-panel-header">
      <h2 class="qa-panel-title">Recent Course Evaluations</h2>
      <button class="qa-action-btn">View All</button>
    </div>
    <div class="qa-panel-body">
      <div class="evaluations-table">
        <div class="evaluation-row evaluation-header">
          <div class="eval-col col-course">Course</div>
          <div class="eval-col col-instructor">Instructor</div>
          <div class="eval-col col-rating">Rating</div>
          <div class="eval-col col-response">Response Rate</div>
          <div class="eval-col col-date">Date</div>
          <div class="eval-col col-status">Status</div>
        </div>
        
        <div class="evaluation-row" *ngFor="let eval of recentEvaluations">
          <div class="eval-col col-course">
            <div class="course-code">{{ eval.courseCode }}</div>
            <div class="course-name">{{ eval.courseName }}</div>
          </div>
          <div class="eval-col col-instructor">{{ eval.instructor }}</div>
          <div class="eval-col col-rating">
            <div class="rating-display">
              <span class="rating-stars">★</span>
              <span class="rating-value">{{ eval.rating }}/5.0</span>
            </div>
          </div>
          <div class="eval-col col-response">
            <div class="response-rate">{{ eval.responseRate }}%</div>
          </div>
          <div class="eval-col col-date">{{ eval.evaluationDate | date:'mediumDate' }}</div>
          <div class="eval-col col-status">
            <span class="status-badge" [ngClass]="getStatusClass(eval.status)">
              {{ eval.status }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Accreditation Status -->
  <div class="qa-panel">
    <div class="qa-panel-header">
      <h2 class="qa-panel-title">Accreditation & Compliance Status</h2>
    </div>
    <div class="qa-panel-body">
      <div class="accreditation-grid">
        <div class="accreditation-card" *ngFor="let item of accreditationItems">
          <div class="accred-header">
            <h3 class="accred-standard">{{ item.standard }}</h3>
            <span class="accred-status-badge" [ngClass]="getStatusClass(item.status)">
              {{ item.status }}
            </span>
          </div>
          
          <div class="accred-compliance">
            <div class="compliance-label">Compliance Level</div>
            <div class="compliance-bar-wrapper">
              <div class="compliance-bar-track">
                <div class="compliance-bar-fill" [style.width.%]="item.complianceLevel"
                     [class.high-compliance]="item.complianceLevel >= 90"
                     [class.medium-compliance]="item.complianceLevel >= 75 && item.complianceLevel < 90"
                     [class.low-compliance]="item.complianceLevel < 75">
                </div>
              </div>
              <span class="compliance-percentage">{{ item.complianceLevel }}%</span>
            </div>
          </div>
          
          <div class="accred-dates">
            <div class="accred-date-item">
              <span class="date-label">Last Review:</span>
              <span class="date-value">{{ item.lastReview | date:'mediumDate' }}</span>
            </div>
            <div class="accred-date-item">
              <span class="date-label">Next Review:</span>
              <span class="date-value">{{ item.nextReview | date:'mediumDate' }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Debug Information -->
  <div class="diagnostics-panel">
    <h3>Debug Information:</h3>
    <p>Component loaded at: {{ currentTime | date:'medium' }}</p>
    <p>Data initialized: {{ recentActivities.length }} activities loaded</p>
  </div>

   <!-- Footer -->
    <div class="slogin-footer-container">
      <p class="slogin-copyright">AUCDT | UITS © 2025 All rights reserved</p>
    </div>